import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/administrative-reports/notification/index.html';

const links: Record<string, string> = {
  stmtPosted: '/infoTrac/administrative-reports',
  paperless: '/infoTrac/administrative-reports/paperless',
  login: '/infoTrac/administrative-reports/login',
  notificationSent: '/infoTrac/administrative-reports/notification-sent',
  emailCollection: '/infoTrac/administrative-reports/email-collection',
  insertClickTracking: '/infoTrac/administrative-reports/insert-click-tracking',
  clickTrackingReport: '/infoTrac/administrative-reports/click-tracking-report',
  admineLoginActivity: '/infoTrac/administrative-reports/admin-login-activity',
  auditLog: '/infoTrac/administrative-reports/audit-log',
  customReport: '/infoTrac/administrative-reports/custom-reports',
  accountCreation: '/infoTrac/administrative-reports/account-creation-report',
  userEnrollment: '/infoTrac/administrative-reports/user-enrollment-report',
};

function Notification() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const stmtPosted = iframeDocument.getElementById('stmtPosted');
      const paperless = iframeDocument.getElementById('paperless');
      const login = iframeDocument.getElementById('login');
      const notificationSent = iframeDocument.getElementById('notificationSent');
      const emailCollection = iframeDocument.getElementById('emailCollection');
      const insertClickTracking = iframeDocument.getElementById('insertClickTracking');
      const clickTrackingReport = iframeDocument.getElementById('clickTrackingReport');
      const adminLoginActivity = iframeDocument.getElementById('admineLoginActivity');
      const auditLog = iframeDocument.getElementById('auditLog');
      const customReport = iframeDocument.getElementById('customReport');
      const accountCreation = iframeDocument.getElementById('accountCreationReport');
      const userEnrollment = iframeDocument.getElementById('user-enrollment-report');

      if (stmtPosted) stmtPosted.addEventListener('click', () => navigate(links.stmtPosted));
      if (paperless) paperless.addEventListener('click', () => navigate(links.paperless));
      if (login) login.addEventListener('click', () => navigate(links.login));
      if (notificationSent) notificationSent.addEventListener('click', () => navigate(links.notificationSent));
      if (emailCollection) emailCollection.addEventListener('click', () => navigate(links.emailCollection));
      if (insertClickTracking) insertClickTracking.addEventListener('click', () => navigate(links.insertClickTracking));
      if (clickTrackingReport) clickTrackingReport.addEventListener('click', () => navigate(links.clickTrackingReport));
      if (adminLoginActivity) adminLoginActivity.addEventListener('click', () => navigate(links.admineLoginActivity));
      if (auditLog) auditLog.addEventListener('click', () => navigate(links.auditLog));
      if (customReport) customReport.addEventListener('click', () => navigate(links.customReport));
      if (accountCreation) accountCreation.addEventListener('click', () => navigate(links.accountCreation));
      if (userEnrollment) userEnrollment.addEventListener('click', () => navigate(links.userEnrollment));
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return <iframe ref={iframeRef} title="notification" src={path} width="100%" height="1800px" />;
}

export default Notification;
